module.exports = __webpack_public_path__ + "img/wa-logo-text.2790fd6f.png";